import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class ReadNextContentDiscoverability extends Component {

    private static healioUrl = "https://www.healio.com";
    private cleanArticleId: string | undefined;
    private primarySpecialtyName: string | undefined;
    private primarySubSpecialtyId: string | undefined;
    private hwsHost: string | undefined;
    private visitedPagesArray: string[] | null;
    private readLoaded: boolean | undefined;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.cleanArticleId = this._element.dataset.cleanArticleId;
        this.primarySpecialtyName = this._element.dataset.primarySpecName;
        this.primarySubSpecialtyId = this._element.dataset.primarySubSpecId;
        this.hwsHost = this._element.dataset.hwsHost;
        this.visitedPagesArray = null;
        this.readLoaded = false;
    }

    public async init(): Promise<void> {
        const readNextElement = this;
        $(async () => {
            if (window.Visitor !== undefined && window.Visitor !== "") {
                readNextElement.loadReadNext();
            } else {
                $(window).on("globalsloaded", () => readNextElement.loadReadNext());
            }
        });
    }

    private filterAlreadyRead(this: ReadNextContentDiscoverability, value: any): any {
        if (this.visitedPagesArray && this.visitedPagesArray.includes("{" + value.url.replace("/find/", "").toUpperCase() + "}")) {
            return false;
        } else {
            return true;
        }
    }
    private filterResponse(input: any): any {
        return input.relatedItems.filter((value: any) => this.filterAlreadyRead(value));
    }
    private loadReadNext(): void {
        if (this.readLoaded) {
            return;
        }
        this.readLoaded = true;
        const readNextElement = this;
        if (typeof (window.Context) === 'undefined') {
            console.warn("window.Context is not defined. Unable to load Read Next");
            return;
        }
        if (window.Visitor.isbot || window.Visitor.type === "DC") {
            return;
        }
        var visitedPages = sessionStorage.getItem("visitedPages");
        readNextElement.visitedPagesArray = visitedPages ? JSON.parse(visitedPages) : null;
        if (readNextElement.visitedPagesArray != null && window.Context?.documentid) {
            if (readNextElement.visitedPagesArray.length < 8) {
                if (!readNextElement.visitedPagesArray.includes(window.Context.documentid)) {
                    readNextElement.visitedPagesArray.push(window.Context.documentid);
                    sessionStorage.setItem("visitedPages", JSON.stringify(readNextElement.visitedPagesArray));
                }
            } else if (window.Context?.documentid) {
                readNextElement.visitedPagesArray.shift();
                readNextElement.visitedPagesArray.push(window.Context.documentid);
                sessionStorage.setItem("visitedPages", JSON.stringify(readNextElement.visitedPagesArray));
            }
        } else if (window.Context?.documentid) {
            readNextElement.visitedPagesArray = [];
            readNextElement.visitedPagesArray.push(window.Context.documentid);
            sessionStorage.setItem("visitedPages", JSON.stringify(readNextElement.visitedPagesArray));
        }

        if (typeof (window.contentBottom) === "undefined") {
            return;
        }



        var tmode = "article";
        var primaryspecname = readNextElement.primarySpecialtyName;
        var primarysubspec = readNextElement.primarySubSpecialtyId;
        if (!primaryspecname || primaryspecname === "") primaryspecname = "na";
        if (!primarysubspec || primarysubspec === "") primarysubspec = "na";
        primaryspecname = primaryspecname.replace(/&#39;/g, '');
        primaryspecname = primaryspecname.replace(/ &/g, '');
        $.ajax({
            type: "GET",
            url: readNextElement.hwsHost + "/~/hws/relatedchips/" + readNextElement.cleanArticleId + "/" + tmode + "/" + primaryspecname + "/" + primarysubspec,
            success: function (msg: any): void {

                var articleContentCount = 4;
                var articleContentElem = document.getElementsByClassName("article__container");

                var articleContentHeight = articleContentElem[0].clientHeight;
                if (articleContentHeight != undefined && articleContentHeight <= 800) {
                    articleContentCount = 3;
                }

                //callback function to use filter with
                var filteredResponse = readNextElement.filterResponse(msg.response);
                // console.log(filteredResponse);

                //get most relevant article and populate hidden element for second article
                var readNextPrimary = filteredResponse[0];
                if (readNextPrimary && readNextPrimary.url !== '' && readNextPrimary.url !== undefined) {
                    $("#recoPrimary a").attr("href", readNextPrimary.url.toString().replace(ReadNextContentDiscoverability.healioUrl, ""));
                } else {
                    return;
                }

                let i: number = 1;
                do {
                    let nextArticle = filteredResponse[i];
                    let cardElem = document.getElementById('rmlrCard' + i);
                    if (cardElem === null) {
                        continue;
                    }
                    console.log(nextArticle);

                    if (nextArticle && nextArticle.url !== '' && nextArticle.url !== undefined) {
                    let postedDate = new Date(nextArticle.posteddate);
                        let formattedPostedDate = postedDate.toLocaleString("en-US", {
                            day: "numeric",
                            month: "long",
                            year: "numeric"
                        });

                        cardElem.querySelectorAll(".date")[0].innerHTML = formattedPostedDate;

                        if (nextArticle.engagementtype !== null && nextArticle.engagementtype === "Listen Now") {
                            cardElem.querySelectorAll(".time")[0].innerHTML = nextArticle.engagementtime + " min listen";
                        } else if (nextArticle.video !== null && nextArticle.video !== "" && nextArticle.engagementtime !== null) {

                            cardElem.querySelectorAll(".time")[0].innerHTML = nextArticle.engagementtime + " min watch";
                        } else if (nextArticle.engagementtime !== null) {
                            cardElem.querySelectorAll(".time")[0].innerHTML = nextArticle.engagementtime + " min read";
                        }

                        // Show TTS icon if hastts is true
                        const ttsIcon = cardElem.querySelectorAll(".tts-icon")[0] as HTMLElement;
                        if (nextArticle.hastts === true) {
                            ttsIcon.classList.remove("d-none");
                        } else {
                            ttsIcon.classList.add("d-none");
                        }

                        cardElem.querySelectorAll(".card-title a")[0].setAttribute("href", nextArticle.url);
                        cardElem.querySelectorAll(".card-title a")[0].innerHTML = nextArticle.title;

                        cardElem.classList.remove("d-none");


                    } else {
                        cardElem.remove();
                    }

                    i++;
                } while (i <= articleContentCount)
                //ReloadSaveIcon("readMoreLeftRail",this.pageContext);
                $("#readMoreLeftRail").removeClass("d-none");


            },
            error: function () {
                console.error("Error loading ReadNext");
            },
            timeout: 5000
        });
    }
}

ComponentFactory.registerComponent("ReadNextContentDiscoverability", ReadNextContentDiscoverability);

// async function ReloadSaveIcon(elemId: string, _pageContext: PageContext) {
//     let targetElem = document.getElementById(elemId);
//         if (targetElem === null || targetElem === undefined)
//             return;
//         await _pageContext?.componentFactory.loadComponents(targetElem)
// }

